import React, { forwardRef } from 'react';
import { VisuallyHiddenStyles } from './VisuallyHidden.styles.js';
import styled from 'styled-components';

const StyledVisuallyHidden = styled.span `
    ${VisuallyHiddenStyles}
`;
const _VisuallyHidden = forwardRef(({ children, ...rest }, ref) => {
    return (React.createElement(StyledVisuallyHidden, { ...rest, ref: ref }, children));
});
_VisuallyHidden.displayName = '_VisuallyHidden';
const VisuallyHidden = _VisuallyHidden;

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.js.map
